import { config } from '../../../config/config';
import { selectCurrency, selectWallets } from '../../account/store/account.store';
import { useAppSelector } from '../../main/store/root.store';

export function useCurrentCurrency() {
    const currency = useAppSelector(selectCurrency);
    const wallets = useAppSelector(selectWallets);
    const hasCurrency = wallets?.find(({ currencyCode }) => currencyCode === currency);

    const initialWalletCurrency = wallets?.length ? wallets[0].currencyCode : null;
    const defaultFallbackCurrency = config.DEFAULT_CURRENCIES[0];

    return (
        (!!hasCurrency && !!currency ? currency : initialWalletCurrency) ?? defaultFallbackCurrency
    );
}
